import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAbandoned = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 18C14.411 18 18 14.4113 18 10C18 7.86133 17.1683 5.85205 15.658 4.34196C14.1476 2.83171 12.1387 2 10 2C5.5887 2 2 5.5887 2 10C2 12.1387 2.83171 14.1479 4.34196 15.658C5.85205 17.1683 7.86133 18 10 18ZM10 16.6667C8.44206 16.6667 6.96663 16.137 5.7793 15.1634L15.1634 5.7793C16.137 6.96663 16.6667 8.44206 16.6667 10C16.6667 13.6759 13.6759 16.6667 10 16.6667ZM10 3.33333C11.5576 3.33333 13.0334 3.86296 14.2204 4.83659L4.83659 14.2207C3.86296 13.0334 3.33333 11.5579 3.33333 10C3.33333 6.32406 6.32406 3.33333 10 3.33333Z",
		fill: "currentColor"
	})
});
export default SvgAbandoned;
